import React from 'react'

//   import { fetchRepository } from 'api'

class About extends React.Component {

     state = {

    }

   
    render() {
        
         
        return (
            <div className="row">
              About HELLO ABOUT
            </div>
        )
    }
}

export default About


// WEBPACK FOOTER //
// ./src/pages/About.react.js